import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Card from '@/components/Card/Card'
import { Grid } from '@/components/Grid'

type Props = {
  activeUsers: number
  enrolledUsers: number
  adherencePercentage?: number
}

export default function EngagementKPI({ activeUsers, enrolledUsers, adherencePercentage }: Props) {
  const { t } = useTranslation()
  const nf = useMemo(() => new Intl.NumberFormat(undefined), [])
  const nfPercent = useMemo(
    () => new Intl.NumberFormat(undefined, { style: 'percent', maximumFractionDigits: 1 }),
    [],
  )

  return (
    <Grid columns="repeat(auto-fit, minmax(180px, 1fr))">
      <Card label={t('usageStats.kpiUsersTotal')} value={nf.format(enrolledUsers)} />

      <Card
        label={t('usageStats.kpiUsersActive')}
        value={nf.format(activeUsers)}
        tooltip={t('usageStats.kpiUsersActiveLabel')}
      />

      <Card
        label={t('usageStats.kpiUsersInactive')}
        value={nf.format(enrolledUsers - activeUsers)}
        tooltip={t('usageStats.kpiUsersInactiveLabel')}
      />

      <Card
        label={t('usageStats.kpiAvgAdherence')}
        value={
          adherencePercentage
            ? nfPercent.format(adherencePercentage / 100)
            : t('usageStats.noRecentLogs')
        }
        tooltip={t('usageStats.kpiAvgAdherenceLabel')}
      />
    </Grid>
  )
}
